export default __webpack_public_path__ + "static/media/Pelvic_Set_Up_Female.6183200d.png";